import * as React from "react"
import {
  BsFacebook,
  BsGithub,
  BsGlobe,
  BsGoogle,
  BsInstagram,
  BsLinkedin,
  BsMessenger,
  BsPinterest,
  BsReddit,
  BsSpotify,
  BsStackOverflow,
  BsTelegram,
  BsTiktok,
  BsWhatsapp,
  BsYoutube,
} from "react-icons/bs"
import { FaDeezer, FaDev, FaXTwitter } from "react-icons/fa6"
import { SiApplemusic, SiDailydotdev, SiImdb, SiLeetcode } from "react-icons/si"

export interface SocialLink {
  url: string
  title: string
  icon: React.ReactNode
}

export const socialLinks: SocialLink[] = [
  {
    url: "https://kiron.dev",
    title: "Portfolio",
    icon: <BsGlobe className="h-5 w-5" />,
  },
  {
    url: "https://leetcode.com/toufiqhasankiron/",
    title: "LeetCode",
    icon: <SiLeetcode className="h-5 w-5" />,
  },
  {
    url: "https://g.co/kgs/jRV7pv",
    title: "Google",
    icon: <BsGoogle className="h-5 w-5" />,
  },
  {
    url: "https://facebook.com/toufiqhasankiron",
    title: "Facebook",
    icon: <BsFacebook className="h-5 w-5" />,
  },
  {
    url: "https://m.me/toufiqhasankiron",
    title: "Messenger",
    icon: <BsMessenger className="h-5 w-5" />,
  },
  {
    url: "https://github.com/kiron0",
    title: "GitHub",
    icon: <BsGithub className="h-5 w-5" />,
  },
  {
    url: "https://instagram.com/toufiq_hasan_kiron/",
    title: "Instagram",
    icon: <BsInstagram className="h-5 w-5" />,
  },
  {
    url: "https://linkedin.com/in/toufiq-hasan-kiron/",
    title: "LinkedIn",
    icon: <BsLinkedin className="h-5 w-5" />,
  },
  {
    url: "https://youtube.com/@toufiqhasankiron",
    title: "YouTube",
    icon: <BsYoutube className="h-5 w-5" />,
  },
  {
    url: "https://x.com/hashtagkiron",
    title: "Twitter",
    icon: <FaXTwitter className="h-5 w-5" />,
  },
  {
    url: "https://tiktok.com/@toufiqhasankiron",
    title: "TikTok",
    icon: <BsTiktok className="h-5 w-5" />,
  },
  {
    url: "https://reddit.com/user/toufiqhasankiron/",
    title: "Reddit",
    icon: <BsReddit className="h-5 w-5" />,
  },
  {
    url: "https://api.whatsapp.com/send?phone=+8801855535091&text=Hey, what's up?",
    title: "WhatsApp",
    icon: <BsWhatsapp className="h-5 w-5" />,
  },
  {
    url: "https://t.me/toufiqhasankiron",
    title: "Telegram",
    icon: <BsTelegram className="h-5 w-5" />,
  },
  {
    url: "https://open.spotify.com/artist/7jHy9ns5u5jyqpWITHuWaV",
    title: "Spotify",
    icon: <BsSpotify className="h-5 w-5" />,
  },
  {
    url: "https://music.apple.com/us/artist/toufiq-hasan-kiron/1696431264",
    title: "Apple Music",
    icon: <SiApplemusic className="h-5 w-5" />,
  },
  {
    url: "https://www.deezer.com/en/artist/216852415",
    title: "Deezer",
    icon: <FaDeezer className="h-5 w-5" />,
  },
  {
    url: "https://stackoverflow.com/users/16756623/toufiq-hasan-kiron",
    title: "Stack Overflow",
    icon: <BsStackOverflow className="h-5 w-5" />,
  },
  {
    url: "https://imdb.com/name/nm13862500",
    title: "IMDB",
    icon: <SiImdb className="h-5 w-5" />,
  },
  {
    url: "https://pinterest.com/toufiqhasankiron",
    title: "Pinterest",
    icon: <BsPinterest className="h-5 w-5" />,
  },
  {
    url: "https://g.dev/kiron",
    title: "Google Dev",
    icon: <FaDev className="h-5 w-5" />,
  },
  {
    url: "https://app.daily.dev/toufiqhasankiron",
    title: "Daily.dev",
    icon: <SiDailydotdev className="h-5 w-5" />,
  },
]
